import { ThemeProvider } from 'styled-components';
import { theme } from './theme/theme';
import { GlobalStyles } from './theme/GlobalStyles';
import { Header } from './components/Header';
import { Menu } from './components/Menu';
import { ArtDecoFrame } from './theme/components/ArtDeco/ArtDecoFrame';
import { Main } from './components/Main';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ArtDecoFrame>
        <Header />
        <Menu />
        <Main />
      </ArtDecoFrame>
    </ThemeProvider>
  );
}

export default App;